// src/firebase.js — Firebase configuration for vmcreation.com
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB4aD534DLXRGq262rdlzUQLiS0j9PGO2E",
  authDomain: "vmcreation-d8f67.firebaseapp.com",
  projectId: "vmcreation-d8f67",
  storageBucket: "vmcreation-d8f67.firebasestorage.app",
  messagingSenderId: "448949863275",
  appId: "1:448949863275:web:a220ae7960f4d9107e422e",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
